<template>
  <el-dialog :visible.sync="visible" class="editDialog" title="台账下载" :close-on-click-modal="false" @close="close" @open="getOpen">
    <el-form :model="detail" class="addDetail" :rules="rules" ref="detail" label-width="100px">
      <el-form-item label="区域选择" prop="areaName">
        <el-input placeholder="请选择特定区域" @focus="checkAreas" class="detail_input" v-model="detail.areaName"></el-input>
        <selectRegion :hasChildNodes="areaTreeMode" :dialogVisible="areaTreeVisible" @regionTreeClose="areaTreeVisible = false" @regionTreeData="selRegionData" :deptId="null">
        </selectRegion>
      </el-form-item>
      <el-form-item label="年份选择" prop="year">
        <el-select v-model="detail.year" placeholder="请选择" :popper-append-to-body="false">
          <el-option v-for="(item, index) in yearList" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="月份选择" prop="month">
        <el-select v-model="detail.month" placeholder="请选择" :popper-append-to-body="false">
          <el-option v-for="(item, index) in monthList" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="tips" style="margin: 20px 0;width: 420px;color:#fff;"><span style="color: red;margin-right: 5px;">*</span>Tips:开始下载前，请先点击检查，获取条件下任务巡检完成情况，未全部巡检完的不支持下载！下载完成后可以去消防安全维修汇总中查看!
    </div>
    <div class="btns">
      <el-button class='w_next_button cancelButton' @click="check">检查</el-button>
      <el-button class='w_next_button confirmButton' style="margin-left: 20px" :disabled="isAccept" @click="startDownload"><span v-if="seconds != 0 && isAccept">{{ seconds }}秒后</span>开始下载
      </el-button>
    </div>
    <div class="situation" v-if="isShowTaskInfo">维修总数：{{ taskInfo.repairSum }}个，已维修数：{{ taskInfo.repairedCount }}个。</div>
  </el-dialog>
</template>

<script>
import { getLatestYear } from 'utils'
export default {
  name: 'ledgerDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: 'adding'
    }
  },
  data() {
    return {
      visible: this.value,
      detail: {},
      rules: {
        areaName: [{ required: true, message: '请选择区域' }],
        year: [{ required: true, message: '请选择年份', trigger: 'change' }],
        month: [{ required: true, message: '请选择月份', trigger: 'change' }]
      },
      yearList: [],
      monthList: [
        {
          label: '01',
          value: 1
        },
        {
          label: '02',
          value: 2
        },
        {
          label: '03',
          value: 3
        },
        {
          label: '04',
          value: 4
        },
        {
          label: '05',
          value: 5
        },
        {
          label: '06',
          value: 6
        },
        {
          label: '07',
          value: 7
        },
        {
          label: '08',
          value: 8
        },
        {
          label: '09',
          value: 9
        },
        {
          label: '10',
          value: 10
        },
        {
          label: '11',
          value: 11
        },
        {
          label: '12',
          value: 12
        }
      ],
      isAccept: true,
      taskInfo: {},
      isShowTaskInfo: false,
      seconds: 0,
      timer: null,
      areaTreeVisible: false,
      areaTreeMode: false
    }
  },
  components: {
    selectRegion: () => import('./selectRegion/index')
  },
  watch: {
    value(val) {
      this.setCurrentValue(val)
    },
    visible(value) {
      this.$emit('input', value)
    },
    detail: {
      handler(val) {
        clearInterval(this.timer)
        this.timer = null
        this.seconds = 0
        this.isAccept = true
        this.isShowTaskInfo = false
      },
      deep: true
    }
  },
  methods: {
    setCurrentValue(val) {
      clearInterval(this.timer)
      this.timer = null
      this.seconds = 0
      this.isAccept = true
      this.isShowTaskInfo = false
      this.detail = {}
      this.seconds = 3
      this.visible = val
      this.yearList = getLatestYear(2, 0)
    },
    getOpen() {
      this.$nextTick(() => {
        this.$refs.detail.clearValidate()
      })
    },
    close() {
      this.detail = {}
      this.$nextTick(() => {
        this.$refs.detail.resetFields()
      })
    },
    checkAreas() {
      this.areaTreeVisible = true
    },
    selRegionData(a) {
      this.$set(this.detail, 'areaName', a.name)
      this.$set(this.detail, 'areaId', a.id)
    },
    check() {
      this.$refs.detail.validate((valid) => {
        if (valid) {
          this.$axiosget('extra/maintenanceRepairTask/check', {
            params: {
              ...this.detail
            }
          }).then((res) => {
            if (res.data.status == 10000) {
              this.isShowTaskInfo = true
              this.taskInfo = res.data.data
              if (
                res.data.data.repairSum > 0 &&
                res.data.data.repairedCount > 0 &&
                res.data.data.repairSum === res.data.data.repairedCount
              ) {
                clearInterval(this.timer)
                this.seconds = 3
                this.timer = setInterval(() => {
                  this.seconds--
                  if (this.seconds <= 0) {
                    this.isAccept = false
                    clearInterval(this.timer)
                  }
                }, 1000)
              } else {
                this.isAccept = true
              }
            }
          })
        }
      })
    },
    startDownload() {
      this.$axiosget(
        `extra/maintenanceRepairTask/batch/download?areaId=${this.detail.areaId}&year=${this.detail.year}&month=${this.detail.month}`
      ).then((res) => {
        if (res.data.status === 10000) {
          let fileAddr = res.data.data
          location.href = process.env.API_HOST + fileAddr
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-form-item__content {
  margin-left: 0 !important;
}

/deep/ .el-dialog__body {
  padding: 20px 40px 20px;
}

.el-dialog__body .btns .confirmButton.is-disabled {
  background: #ccc !important;
}

.btns,
.situation {
  display: flex;
  justify-content: center;
}

.btns {
  padding-right: 20px;
}

.situation {
  width: 80%;
  padding: 12px 0;
  border: 1px solid #2d374d;
  margin: 20px 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 15px;
}

.w_next_button {
  width: 150px;
}

.situation {
  width: 80%;
  padding: 12px 0;
  border: 1px solid #2d374d;
  margin: 20px 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/wbManage/maintainTask/ledgerDialog.vue